export default __webpack_public_path__ + "static/media/save-cookbook-active.9e79869b.svg";